import styled from '@emotion/styled'

type FieldblockProps = {
	label: string
	children: React.ReactNode
}

const FieldBlock = ({ label, children }: FieldblockProps) => {
	return (
		<Block>
			<Label>{label}</Label>
			{children}
		</Block>
	)
}

const Block = styled.div`
	display: flex;
	flex-direction: column;

	& + & {
		margin-top: 3rem;
	}
`

const Label = styled.label`
	font-size: 1.5rem;
	font-weight: 500;
	padding: 0.5rem 0;
	line-height: 1.6rem;
`

export default FieldBlock
